module.exports = __webpack_public_path__ + "img/431460c.png";